import { render, staticRenderFns } from "./StudentSubjectGroup.vue?vue&type=template&id=3b367aae"
import script from "./StudentSubjectGroup.vue?vue&type=script&lang=js"
export * from "./StudentSubjectGroup.vue?vue&type=script&lang=js"
import style0 from "./StudentSubjectGroup.vue?vue&type=style&index=0&id=3b367aae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports